import { render } from "./TrainingSectionContent.vue?vue&type=template&id=7bc271ac&scoped=true"
import script from "./TrainingSectionContent.vue?vue&type=script&lang=js"
export * from "./TrainingSectionContent.vue?vue&type=script&lang=js"

import "./TrainingSectionContent.vue?vue&type=style&index=0&id=7bc271ac&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc271ac"]])

export default __exports__